import { MakeDeposit } from '@/components/account-tools';
import store from '@/store';
import {
  SubmitClaim,
  ActivateHSA,
} from '@/components/account-components/account-tools';
import { RouteConfig } from 'vue-router';

export const accountToolRoutes: RouteConfig[] = [
  {
    name: 'submitClaim',
    path: '/submit-claim/:step',
    component: SubmitClaim,
    meta: {
      transitionIn: 'slide-up',
      transitionMode: 'in-out',
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('setPreviousRoute', from);
      next();
    },
  },
  {
    name: 'submitClaimGetReimbursedDefault',
    path: '/submit-claim',
    redirect: {
      name: 'submitClaim',
      params: {
        step: '1',
        action: 'reimburse',
      },
    },
  },
  {
    name: 'payBill',
    path: '/pay-bill/:step',
    component: SubmitClaim,
    meta: {
      transitionIn: 'slide-up',
      transitionMode: 'in-out',
    },
    beforeEnter: (to, from, next) => {
      to.params.action = 'pay-bill';
      store.dispatch('setPreviousRoute', from);
      next();
    },
  },
  {
    name: 'submitClaimPayBillDefault',
    path: '/pay-bill',
    redirect: {
      name: 'payBill',
      params: {
        step: '1',
        action: 'pay-bill',
      },
    },
  },
  {
    name: 'makeDeposit',
    path: '/make-deposit/:step',
    component: MakeDeposit,
    meta: {
      transitionIn: 'slide-up',
      transitionMode: 'in-out',
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('setPreviousRoute', from);
      next();
    },
  },
  {
    name: 'makeDepositDefault',
    path: '/make-deposit',
    redirect: {
      name: 'makeDeposit',
      params: {
        step: '1',
      },
    },
  },
  {
    name: 'activateHSA',
    path: '/activate-hsa/:step?', // a param can be made optional by adding "?"
    component: ActivateHSA,
    meta: {
      transitionIn: 'slide-up',
      transitionMode: 'in-out',
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('setPreviousRoute', from);
      next();
    },
  },
];
